define('plugin/product/model/ProductCategoryModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    return BaseModel.extend({

        defaults: {
            id: null,
            name: '',
            description: '',
        }

    });

});
